export default __webpack_public_path__ + "static/media/dribbble_logo_white.728c746b.svg";